var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15l3-8H3l-3 8zM2 6l-2 9V2h4.5l2 2H13v2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirIcon);
export default __webpack_public_path__ + "static/media/dir-icon.a5bdf12dc1ecb57eafcdb42234378f46.svg";
export { ForwardRef as ReactComponent };